import stbAPIGateway from '../../../../services/stbAPIGateway';

export const patchExcursionStudentSelection = async (
  { rootGetters },
  { excursionId, payload, queryParams }
) => {
  const axios = rootGetters['app/stbAxios'];
  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.patchExcursionStudentsSelection(excursionId, payload, queryParams);
  return response;
};
